import { useAccordionDropdownContext } from '../contexts/accordion-dropdown-context';
import { GroupOptionsAccordion } from '../group-options-accordion';

export const DropdownTrigger = () => {
	const { isMenuOpen, toggleMenuOpen, createTriggerLabel, indicatorIcon } = useAccordionDropdownContext();

	return (
		<div 
			className="dropdown dropdown--right"
			data-open={isMenuOpen}
		>
			<div 
				className="dropdown__btn"
				onClick={toggleMenuOpen}
			>
				<div className="dropdown__current">
					{createTriggerLabel()}
				</div>
				{indicatorIcon}
			</div>

			{isMenuOpen ? <GroupOptionsAccordion /> : null}
		</div>
	);
};